export const environment = {
  production: true,
  api: 'https://api-patisfraux.agence-11h10.fr',
  url : 'https://www.patisfraux.fr'
};

